import { Component, OnInit, ChangeDetectorRef, Inject, DOCUMENT } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { cloneDeep } from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as FS from 'file-saver';
import { DialogSubmitComponent } from './dialog/dialog-submit.component';
import { DialogConfirmSubmissionComponent } from './dialog/dialog-confirm-submission.component';

import {
  DialogWithdrawComponent,
  DialogWithdrawData
} from './dialog/dialog-withdraw.component';

import {
  AuthenticationService,
  ApplicationApiService,
  OptionSetsApiService,
  ApprovalTaskItemApiService,
  ApplicationEventApiService,
  PrintApiService,
  RecipientApiService,
  ProgramRuleApiService
} from '../data-services/index';

import {
  IUser,
  IApplication, IApplicationInput,
  IApprovalTask,
  IApprovalTaskItem, IApprovalTaskItemInput,
  IApplicationEventInput,
  IHelp, HelpApiService,
  IOptionSets, IOptions, IProgramCycle, IApplicationSubmitInput, IRecipient, IAdditionalTaskItem, AdditionalTaskItemApiService,
  IProgramRule} from '@ebb-v2/ebb-integration';

import { DialogConfirmMessageComponent } from './dialog/dialog-confirm-message.component';
import {  of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'ebb-portal-application',
    templateUrl: './application.component.html',
    standalone: false
})
export class ApplicationComponent implements OnInit {
  public currentUser: IUser;
  public currentApp: IApplication;
  public currentAppId: string;
  public currentAppName: string;
  public currentAppNumber: string;
  public currentAppStage: string;
  public currentAppDue: number;
  public currentAppDueMsg: string;
  public currentAppProgramCycleId: string;
  public programCycleMultipleDwellingsAllowed: boolean;
  public programCycles: IProgramCycle[];
  public noAppMessage = 'Loading...';

  public listHelp: IHelp[] = [];
  public listAdditionalTaskItem: IAdditionalTaskItem[] = [];
  public textProfileNeedsUpdate: string;
  public displaySubmitApplication = false;
  public displayProgramRulesAcknowledge: boolean;
  public displayProgramRulesAcknowledgeProgramType: number;
  public resolvedOptions: IOptionSets[] = [];
  public withdrawOptions: IOptionSets[] = [];
  public WithdrawEventTypeOptions: IOptions[] = {} as IOptions[];
  public OtherWithdrawOption: IOptions = {} as IOptions;
  public programTypeCodeOptionSet: string;
  public uriSpaRegistration: string;
  public femareviewmessage: string;
  public submitVotePreRetrofit = false;
  public submitVotePostRetrofit = false;
  public canShowSubmitDialog = true;
  public readonly stageCodePreRetrofit: number = 700000000;
  public readonly stageCodePostRetrofit: number = 700000001;
  public isSgWaitList = false;
  public queryParmSubscription;
  public DocuSignEventStatus: string;
  public DocuSignRecipientId: string;
  public allowWithDrawApplication = false;
  public listRule: IProgramRule[] = [];
  /**********************
   * Toolbar
   */
  public showEditContractor = false;
  public showactive = false;
  public cardLayout = 100 / 3 + '%';
  constructor(
    private readonly actRoute: ActivatedRoute,
    private readonly authenticationService: AuthenticationService,
    private readonly apiApplication: ApplicationApiService,
    private readonly apiRecipient: RecipientApiService,
    private readonly apiApprovalTaskItem: ApprovalTaskItemApiService,
    private readonly apiApplicationEvent: ApplicationEventApiService,
    private readonly apiHelp: HelpApiService,
    private readonly apiAdditionalTaskItem: AdditionalTaskItemApiService,
    private readonly apiOptionSets: OptionSetsApiService,
    private readonly apiPrint: PrintApiService,
    private readonly dialogSubmit: MatDialog,
    private readonly dialogConfirmSubmit: MatDialog,
    private readonly dialogWithdraw: MatDialog,
    private readonly router: Router,
    private readonly cdRef: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly snackBar: MatSnackBar,
    private readonly apiProgramRule: ProgramRuleApiService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.route.queryParams.subscribe((params) => {
      const programLocalStore = localStorage.getItem('ebbprogram');
      if (window['program']) {
        this.programTypeCodeOptionSet = window['program'];
      } else if (programLocalStore) {
        this.programTypeCodeOptionSet = programLocalStore;
      } else {
        this.programTypeCodeOptionSet = 'FEMA|EBB'; //default to EBB programs
      }
    });
  }

  async ngOnInit() {
    console.log('application.component.ngOnInit begin');
    await this.loadAdditionalTaskItemData();
    this.queryParmSubscription = this.route.queryParamMap.subscribe(
      async (params) => {
        console.log('application.component.ngOnInit evaluate params');
        this.DocuSignEventStatus = params.get('event');
        this.DocuSignRecipientId = params.get('recipientId');

        console.log(
          'application.component.ngOnInit this.DocuSignEventStatus=' +
            this.DocuSignEventStatus
        );

        console.log(
          'application.component.ngOnInit this.DocuSignRecipientId=' +
            this.DocuSignRecipientId
        );

        this.actRoute.paramMap.subscribe((params) => {
          this.currentAppId = params.get('id');
        });

        if (
          this.DocuSignEventStatus != null &&
          this.DocuSignRecipientId != null
        ) {
          //update recipient with DocuSign event status. e.g.
          //ttl_expired
          //signing_complete
          const recipientInput: IRecipient = {} as IRecipient;
          const date = new Date();

          if (
            this.DocuSignEventStatus === 'viewing_complete' ||
            this.DocuSignEventStatus === 'ttl_expired'
          ) {
            this.DocuSignEventStatus = 'signing_complete';
          }

          recipientInput.signingDateInput = date.toUTCString();
          recipientInput.signingStatus = this.DocuSignEventStatus;
          await this.UpdateRecipent(recipientInput);
        }
      }
    );

    this.currentUser = this.authenticationService.currentUserValue;
    this.uriSpaRegistration = this.authenticationService.uriSpaRegister;
    const hostName = window.location.hostname;
    if (hostName.includes('earthquakeauthority')) {
      this.uriSpaRegistration =
        '/prepare-your-house-earthquake-risk/brace-and-bolt-grants/cea-policyholder-brace-bolt-grants/register/';
    }
    this.programTypeCodeOptionSet = this.authenticationService.programType;
    this.resolvedOptions = this.actRoute.snapshot.data['options'];
    this.programCycles = this.actRoute.snapshot.data['programCycles'];
    const programsSplit = this.programTypeCodeOptionSet.split('|');

    const availableProgramCycles = this.programCycles.filter((programCycle) =>
      programsSplit.includes(programCycle.typeCodeOptionSet)
    );
    const availableFemaProgram = availableProgramCycles.filter(
      (programCycle) => programCycle.typeCodeOptionSet === 'FEMA'
    )[0];

    if (
      (availableFemaProgram && availableFemaProgram.multipleDwellings) ||
      (availableProgramCycles[0] && availableProgramCycles[0].multipleDwellings)
    ) {
      this.programCycleMultipleDwellingsAllowed = true;
    } else {
      this.programCycleMultipleDwellingsAllowed = false;
    }

    this.actRoute.paramMap.subscribe((params) => {
      this.currentAppId = params.get('id');
      if (this.currentAppId && this.currentAppId.length > 0) {
        this.loadAppData(this.currentAppId);
      } else {
        console.warn(`application.onInit() cannot load application`);
      }
    });
    this.loadAppEventOptionsData();
    this.loadHelpData();
  }

  public async UpdateRecipent(recipientInput: IRecipient): Promise<void> {
    this.apiRecipient
      .SaveRecipient(
        this.DocuSignRecipientId,
        recipientInput,
        this.currentAppId
      )
      .subscribe(
        (data) => {
          if (data.signingStatus == 'signing_complete') {
            this.onConfirmMessage();
          }

          console.log(
            'application.component.ngOnInit no error saving recipient'
          );
        },
        (error) =>
          console.warn(
            'application.component.ngOnInit error saving recipient',
            error
          )
      );
  }

private loadAppData(id: string): void {
  this.apiApplication.getApplication(id).pipe(
    switchMap(data => {
      this.currentApp = cloneDeep(data) as IApplication;
      this.setAppValues();
      this.showactive = this.currentApp.stateCode === 0;
      this.cdRef.detectChanges();

      if (this.isContractor() && this.currentApp._Ebb_OwnerId === this.currentUser.id) {
        this.router.navigate(['loading']);
      }

      if (this.isHomeowner()) {
        this.allowWithDrawApplication =
          this.currentApp.stateCode === 0 &&
          this.currentAppStage !== '700000003';
        if(this.currentApp.stateCode === 0 && this.currentApp.applicationStatus !== 700000018) {

        if (this.listRule.length === 0) {
          const programTypeCodes: number[] = [];

          if (this.currentApp?.programType != null) {
            this.displayProgramRulesAcknowledgeProgramType = this.currentApp.programType;
            programTypeCodes.push(this.currentApp.programType);
          }

          if ([700000001, 700000002, 700000004].includes(this.currentApp?.sGStatus ?? -1)) {
            programTypeCodes.push(700000005);
          }

          return this.apiProgramRule.getProgramRuleList(programTypeCodes);
        }
      }
      }

      // if no need to fetch rules, return EMPTY observable
      return of([]);
    })
  ).subscribe(rules => {
    if (rules.length > 0) {
      this.listRule = cloneDeep(rules) as IProgramRule[];
        this.CheckRules();
    }
  
  }, error => console.warn(error));
}


  private CheckRules(): void {
    if (!Array.isArray(this.listRule) || this.listRule.length === 0) {
      return;
    }
     const now = new Date();
     
    if(this.currentApp.programRulesAcknowledged === true) {  

  const pendingRules = this.listRule.filter(rule => {
  const isSgRule =
    Array.isArray(rule.programTypeCode) &&
    rule.programTypeCode.includes(700000005);

  const ackDateStr = isSgRule
    ? this.currentApp?.sgAcknowledgedDate
    : this.currentApp?.acknowledgedDate;
const parseDate = (d?: string | Date | null): Date | null => {
  if (!d) return null;                       // handle null/undefined
  const dt = d instanceof Date ? d : new Date(d); 
  return isNaN(dt.getTime()) ? null : dt;    // check for invalid date
};
      const effDate = parseDate(rule?.effectiveDate);
      const ackDate = parseDate(ackDateStr);
      // 1) No acknowledgement => always pending
      if (!ackDate) return true;

      // 2) If effective date is missing/invalid:
      //    - ack exists -> NOT pending
      if (!effDate) return false;

      // 3) If effective date is in the future (and ack exists) => skip for now
      if (effDate > now) return false;

      // 4) If acknowledgement older than effective date => pending
      if (ackDate < effDate) return true;

      // 5) Otherwise NOT pending
      return false;

});
    // Replace with only pending rules
    this.listRule = pendingRules;

  }
    // Show dialog if needed
    this.displayProgramRulesAcknowledge = this.listRule.length > 0;
    if (this.displayProgramRulesAcknowledge) {
      this.displayProgramRulesAcknowledgeProgramType =
        this.currentApp?.programType;
    }
  }

  private setAppValues(): void {
    this.currentAppId = this.currentApp.id;
    this.currentAppName = this.currentApp.name;
    this.currentAppNumber = this.currentApp.applicationNumber;
    this.currentAppStage =
      this.currentApp.applicationStatusOptionSet === 'Extension'
        ? this.currentApp.applicationStatusOptionSet
        : this.currentApp.stageCodeOptionSet;
    this.currentAppProgramCycleId = this.currentApp._Ebb_ProgramCycleId;

    if (
      parseInt(this.currentApp.stageCode.toString(), 10) === 700000000 &&
      this.currentApp.eventPreliminaryReview !== true
    ) {
      this.checkDueDate(this.currentApp.preRetrofitDue);
    } else if (
      parseInt(this.currentApp.stageCode.toString(), 10) === 700000001 &&
      this.currentApp.eventApplicationSubmitted !== true
    ) {
      this.checkDueDate(this.currentApp.postRetrofitDue);
    }
  }

  private checkDueDate(nextStageDue: Date): void {
    const dateToday: Date = new Date();
    let dateDue: Date = null;
    if (nextStageDue) {
      dateDue = new Date(nextStageDue.toString());

      const timeToday = dateToday.getTime();
      const timeDue = dateDue.getTime();

      this.currentAppDue = Math.floor(
        (timeDue - timeToday) / (24 * 3600 * 1000)
      );

      this.currentAppDue > 0
        ? (this.currentAppDueMsg = ` days remaining`)
        : (this.currentAppDueMsg = `Overdue`);
    } else {
      this.currentAppDueMsg = '';
    }
  }
  private async loadAdditionalTaskItemData(): Promise<void> {
    this.apiAdditionalTaskItem.getList().subscribe(
      async (_data) => {
        var data = cloneDeep(_data);
        this.listAdditionalTaskItem = JSON.parse(JSON.stringify(data));
        console.log(data);
      },
      (error) => console.warn(error)
    );
  }
  private loadHelpData(): void {
    this.apiHelp.getList().subscribe(
      (data) => {
        this.listHelp = JSON.parse(JSON.stringify(data));

        const indexHelpProfile = this.listHelp.findIndex(
          (i) => i.name.toLowerCase() === 'profileneedsupdate'
        );
        this.textProfileNeedsUpdate = this.listHelp[indexHelpProfile].answer;
        const femaReviewMessage = this.listHelp.findIndex(
          (i) => i.name.toLowerCase() === 'femareviewmessage'
        );
        this.femareviewmessage = this.listHelp[femaReviewMessage].answer;
      },
      (error) => console.warn(error)
    );
  }
  private getdisplayProgramRulesAcknowledge(): boolean {
    return this.displayProgramRulesAcknowledge;
  }
  private loadAppEventOptionsData(): void {
    this.apiOptionSets.getList('applicationevent').subscribe(
      (data) => {
        this.withdrawOptions = data;
        const indexeventOptions = this.withdrawOptions.findIndex(
          (i) => i.name === 'cea_event_type'
        );
        this.WithdrawEventTypeOptions = [
          ...this.withdrawOptions[indexeventOptions].options,
        ];
      },
      (error) => console.warn(error)
    );
  }

  public goToUrl(url: string): void {
    this.document.location.href = url;
  }

  public multipleAppsAllowed(): number {
    if (this.programCycleMultipleDwellingsAllowed) {
      return 2;
    } else {
      return 1;
    }
  }

  public checkApplicationStatus(): number {
    let retVal = 1;

    if (this.currentApp === undefined || this.currentApp === null) {
      return retVal;
    }

    if (
      (this.currentApp.stageCode === 700000000 &&
        this.currentApp.eventPreliminaryReview) ||
      (this.currentApp.stageCode === 700000001 &&
        this.currentApp.eventApplicationSubmitted)
    ) {
      retVal = 2;
    }

    if (this.currentApp.itemsRejectedRollup > 0) {
      retVal = 3;
    }

    if (this.currentApp.applicationStatus === 700000014) {
      retVal = 4;
    }
    if (
      this.currentApp.stateCode === 1 &&
      this.currentApp.statusCode === 700000000
    ) {
      retVal = 5;
    }

    if (
      this.currentApp.stateCode === 1 &&
      this.currentApp.statusCode === 700000001
    ) {
      retVal = 6;
    }

    return retVal;
  }

  /**********************************************
   * Emit
   */

  public onEmitContractorChangeEvent(input: IApplicationInput): void {
    const thisRef = this;
    Object.keys(input).forEach(function (key) {
      thisRef.currentApp[key] = input[key];
    });
    this.loadAppData(this.currentApp.id);
  }
  public onEmitLdpChangeEvent(input: IApplicationInput): void {
    const thisRef = this;
    Object.keys(input).forEach(function (key) {
      thisRef.currentApp[key] = input[key];
    });
    this.loadAppData(this.currentApp.id);
  }

  public onEmitPermitInfoChange(value: IApplicationInput): void {
    this.loadAppData(this.currentApp.id);
  }

  public onEmitReceiptsPreInfoChange(value: IApplicationInput): void {
    this.loadAppData(this.currentApp.id);
  }
  public onEmitEventInspectionChange(value: IApplicationInput): void {
    // TO DO
  }

  public onEmitFileChangeEvent(input: IApprovalTask): void {
    this.loadAppData(this.currentApp.id);
  }

  public onEmitBidInvoiceInitEvent(): void {
    this.loadAppData(this.currentApp.id);
  }

  public onEmitDataFormChange(value: IApprovalTask): void {
    this.loadAppData(this.currentApp.id);
  }
  public onEmitIVRChange(value: IApprovalTask): void {
    this.loadAppData(this.currentApp.id);
  }

  public onEmitSubmitApplication(input: IApplicationSubmitInput): void {
    // If app is in pre-retrofit stage, we only need vote from pre-retrofit stage.
    if (this.currentApp.stageCode === this.stageCodePreRetrofit) {
      if (input.stageCode === this.stageCodePreRetrofit) {
        this.displaySubmitApplication = input.submit;
      } else {
        this.displaySubmitApplication = false;
        console.warn(
          'ApplicationComponent.onEmitSubmitApplication: invalid condition'
        );
      }
    } else {
      // App is NOT in pre-retrofit stage (I.e. app is in post-retrofit stage).
      // We can't submit until affirmative votes have been cast, from both pre-retrofit stage and post-retrofit stage.
      input.stageCode === this.stageCodePreRetrofit
        ? (this.submitVotePreRetrofit = input.submit)
        : (this.submitVotePostRetrofit = input.submit);
      this.displaySubmitApplication =
        this.submitVotePreRetrofit === true &&
        this.submitVotePostRetrofit === true;
    }

    if (
      this.displaySubmitApplication === true &&
      this.canShowSubmitDialog === true
    ) {
      this.showSubmitDialog();
      // Clear the votes for next evaluation
      this.submitVotePreRetrofit = false;
      this.submitVotePostRetrofit = false;
    }
  }

  public onEmitProgramRulesAcknowledged(value: boolean): void {
    const applicationInput: IApplicationInput = {} as IApplicationInput;
    if (this.currentApp.programRulesAcknowledged !== true) {
      applicationInput.programRulesAcknowledged = true;
    }
    applicationInput.programRulesAcknowledged = true;
    var includemain = this.listRule.some(
      (rule) =>
        Array.isArray(rule.programTypeCode) &&
        rule.programTypeCode.includes(this.currentApp.programType)
    );

    if (includemain) {
      applicationInput.acknowledgedDate = new Date();
    }
    var includeSg = this.listRule.some(
      (rule) =>
        Array.isArray(rule.programTypeCode) &&
        rule.programTypeCode.includes(700000005)
    );
    if (includeSg) {
      applicationInput.sgAcknowledgedDate = new Date();
    }
    this.apiApplication
      .updateApplication(applicationInput, this.currentApp.id)
      .subscribe(
        (data) => {
          console.log('program rules acknowledged success', data);
          this.displayProgramRulesAcknowledge = false;
        },
        (error) => console.warn(error)
      );
  }

  public showPreRetrofitApprovedMessage(): boolean {
    return (
      this.currentApp &&
      this.currentUser &&
      this.currentApp.stageCode &&
      this.currentApp.stageCode === 700000001 &&
      !this.currentApp.eventApplicationSubmitted &&
      !this.isContractor()
    );
  }

  public sgWaitList(): boolean {
    if (this.currentApp.sGStatus === null) {
      return false;
    }
    if (this.currentApp.sGStatus === 700000001) {
      return true;
    }

    return false;
  }
  public isPolicyExpired(): boolean {
    return (
      this.currentApp &&
      this.currentApp.policy &&
      this.currentApp.stateCode === 0 &&
      this.currentApp.policy.expirationDate !== null &&
      new Date(this.currentApp.policy.expirationDate) < new Date()
    );
  }

  /**********************************************
   * Contractor
   */

  public onShowEditContractor() {
    this.showEditContractor
      ? (this.showEditContractor = false)
      : (this.showEditContractor = true);
  }

  public onClickCloseContractor() {
    this.showEditContractor = false;
  }

  /**********************************************
   * Submit Application
   */
  public showSubmitDialog(): void {
    this.canShowSubmitDialog = false;
    const dialogRef = this.dialogSubmit.open(DialogSubmitComponent, {
      width: '300px',
      data: {
        userIsHomeowner: this.isHomeowner(),
        application: this.currentApp,
        submitApplication: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      let isResubmit = false;
      this.canShowSubmitDialog = true;
      if (result && result === 'yes') {
        const applicationInput: IApplicationInput = {} as IApplicationInput;
        if (this.currentApp.stageCode === 700000000) {
          applicationInput.eventPreliminaryReview = true;
        } else if (this.currentApp.stageCode === 700000001) {
          applicationInput.eventApplicationSubmitted = true;
        }

        applicationInput.submissionRejection = 700000000;
        applicationInput.itemsRejectedtotal = 0;

        const markitems: IApprovalTaskItem[] = [];
        this.currentApp.approvalTasks.forEach((task) => {
          task.approvalTaskItems.forEach((item) => {
            markitems.push(item);
          });
        });
        let applicationNote = '';

        if (this.isHomeowner()) {
          applicationInput.submittedBy = 700000000;
          applicationNote =
            'Application is submitted for review and homeowner have attested to providing true and correct information to the best of their knowledge.';
        } else if (this.isContractor()) {
          applicationInput.submittedBy = 700000001;
          applicationNote =
            'Application is submitted for review and contractor have attested to providing true and correct information to the best of their knowledge.';
        } else {
          // fallback (if neither case applies)
          applicationNote =
            'Application is submitted for review and have attested to providing true and correct information to the best of their knowledge.';
        }
      
       
        this.apiApplication
          .updateApplication(applicationInput, this.currentApp.id,applicationNote)
          .subscribe(
            (data) => {
              isResubmit = this.markApprovalitems(markitems, isResubmit);
            },
            (error) => console.warn(error)
          );
      }
    });
  }

  private markApprovalitems(
    markitems: IApprovalTaskItem[],
    isResubmit: boolean
  ) {
    markitems
      .filter((item) => item.submissionReject !== 0)
      .forEach((item) => {
        const itemEdit: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
        itemEdit.id = item.id;
        itemEdit.submissionReject = 0;
        this.apiApprovalTaskItem
          .saveItem(itemEdit, this.currentApp.id, item._Ebb_ApprovalTaskId)
          .subscribe();
        if (item.submissionReject && item.submissionReject !== 0) {
          isResubmit = true;
        }
      });
    const dialogViewDataItem = { wasResubmit: isResubmit };
    const dialogRefConfirm = this.dialogConfirmSubmit.open(
      DialogConfirmSubmissionComponent,
      { width: '300px', data: dialogViewDataItem }
    );
    dialogRefConfirm.afterClosed().subscribe((result) => {
      this.router.navigate(['home']);
    });
    return isResubmit;
  }

  /**********************************************
   * Print Application
   */
  public onPrintEvent(): void {
    this.apiPrint
      .getPrint(
        this.currentApp.id,
        this.displaySubmitApplication ? 'In process' : 'Submitted'
      )
      .subscribe((data) => {
        let navigator: any = window.navigator;
        if (navigator && navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(
            data,
            this.currentAppNumber + '_print.pdf'
          );
        } else if (
          navigator.userAgent.match('CriOS') ||
          (navigator.userAgent.match(/Chrome/i) &&
            navigator.userAgent.match(/Mobile/i))
        ) {
          const fileUrl = URL.createObjectURL(data);
          window.open(fileUrl);
        } else {
          const file = new Blob([data], { type: 'application/pdf' });
          FS.saveAs(file, this.currentAppNumber + '_print.pdf');
        }
      });
  }

  /**********************************************
   * DRV Application
   */
  public onDrvEvent(): void {
    this.apiPrint.getDrv(this.currentApp.id).subscribe((data) => {
      let navigator: any = window.navigator;
      if (navigator && navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(data, this.currentAppNumber + '_drv.pdf');
      } else if (
        navigator.userAgent.match('CriOS') ||
        (navigator.userAgent.match(/Chrome/i) &&
          navigator.userAgent.match(/Mobile/i))
      ) {
        const fileUrl = URL.createObjectURL(data);
        window.open(fileUrl);
      } else {
        const file = new Blob([data], { type: 'application/pdf' });
        FS.saveAs(file, this.currentAppNumber + '_drv.pdf');
      }
 
    });
  }

  /**********************************************
   * Retrofit Verification Application
   */
  public onRetrofitEvent(): void {
    this.apiPrint
      .getRetrofitVerification(this.currentApp.id)
      .subscribe((data) => {
        let navigator: any = window.navigator;
        if (navigator && navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(
            data,
            this.currentAppNumber + '_retrofitverification.pdf'
          );
        } else if (
          navigator.userAgent.match('CriOS') ||
          (navigator.userAgent.match(/Chrome/i) &&
            navigator.userAgent.match(/Mobile/i))
        ) {
          const fileUrl = URL.createObjectURL(data);
          window.open(fileUrl);
        } else {
          const file = new Blob([data], { type: 'application/pdf' });
          FS.saveAs(file, this.currentAppNumber + '_retrofitverification.pdf');
        }
      });
  }

  public showDrvPrint(): boolean {
    return (
      this.currentUser &&
      this.isHomeowner() &&
      this.currentApp &&
      this.currentApp.stageCode === 700000003 &&
      this.currentApp.applicationStatus === 700000018 &&
      this.isDrvEligible()
    );
  }

  public showRetrofitPrint(): boolean {
    if (this.currentApp.programType === 700000004) {
      return false;
    }
    return (
      this.currentUser &&
      this.isHomeowner() &&
      this.currentApp &&
      this.currentApp.stageCode === 700000003 &&
      this.currentApp.applicationStatus === 700000018 &&
      this.currentApp.programType !== 700000000
    );
  }

  private isDrvEligible(): boolean {
    if (this.currentApp.programType === 700000004) {
      return false;
    }
    return (
      this.currentApp.programType !== 700000003 ||
      (this.currentApp.programType === 700000003 &&
        this.currentApp.drvEligible === true &&
        this.currentApp.retrofitType === 700000004)
    );
  }

  /**********************************************
   * Withdraw Application
   */
  public onWithdrawEvent(): void {
    const that = this;
    const dialogWithdrawItem: DialogWithdrawData = {} as DialogWithdrawData;
    const withdrawfilteroptions = that.WithdrawEventTypeOptions.filter((x) =>
      x.label.startsWith('Withdraw')
    );
    const otherwithdrawOptions = {} as IOptions;
    const WithdrawTypeOptions: IOptions[] = [];
    withdrawfilteroptions.forEach(function (option) {
      const withdrawOptions = {} as IOptions;
      const label = option.label.replace('Withdraw : ', '');
      if (label.startsWith('Other')) {
        otherwithdrawOptions.value = option.value;
        otherwithdrawOptions.label = label;
      } else {
        withdrawOptions.label = label;
        withdrawOptions.value = option.value;
        WithdrawTypeOptions.push(withdrawOptions);
      }
    });
    WithdrawTypeOptions.push(otherwithdrawOptions);
    dialogWithdrawItem.reasonoptions = WithdrawTypeOptions;

    const dialogRef = that.dialogWithdraw.open(DialogWithdrawComponent, {
      width: '400px',
      data: dialogWithdrawItem,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const application: IApplicationInput = {} as IApplicationInput;
        const applicationeventInut: IApplicationEventInput =
          {} as IApplicationEventInput;

        applicationeventInut.name = 'Withdraw';
        applicationeventInut.eventDescription = dialogWithdrawItem.otherreason;
        applicationeventInut.eventType = parseInt(
          dialogWithdrawItem.reason.toString(),
          10
        );
        applicationeventInut._Ebb_ApplicationId = this.currentAppId;
        application.statusCode = 700000001;
        application.stateCode = 1;
        that.apiApplicationEvent
          .updateApplicationEvent(applicationeventInut)
          .subscribe(
            (result) => {},
            (err) => console.warn(`ERROR:updateApplicationEvent() - ${err}`)
          );
        that.apiApplication
          .updateApplication(application, that.currentAppId)
          .subscribe(
            (data) => {
              that.currentApp.stateCode = application.stateCode;
              that.currentApp.statusCode = application.statusCode;
              that.router.navigate(['']);
            },
            (err) => console.warn(`ERROR:onWithdrawEvent() - ${err}`)
          );
      }
    });
  }
  /***     WithDraw SG */
  public onEmitWithDrawSG(): void {
    const applicationInput: IApplicationInput = {} as IApplicationInput;
    applicationInput.sGStatus = 700000005;
    const that = this;
    that.apiApplication
      .updateApplication(applicationInput, this.currentApp.id)
      .subscribe(
        (data) => {
          console.log('SG With Draw success', data);
          that.router.navigate(['']);
        },
        (error) => console.warn(error)
      );
  }

  public onConfirmMessage(): void {
    localStorage.setItem('refresh', 'true');

    const dialogViewDataItem = {
      message: 'Thank you for completing the income verification form.',
      buttonlabel: 'CLOSE',
    };
    const dialogRefConfirm = this.dialogConfirmSubmit.open(
      DialogConfirmMessageComponent,
      { width: '400px', data: dialogViewDataItem }
    );
    dialogRefConfirm.afterClosed().subscribe((result) => {
      const url: string = this.router.url.substring(
        0,
        this.router.url.indexOf('?')
      );
      this.router.navigateByUrl(url);
      this.loadAppData(this.currentApp.id);
    });
  }

  /***     User Convenience Methods */
  public isHomeowner(): boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }

  public isInspector() {
    return this.authenticationService.isInspector(this.currentUser);
  }

  public programTypeDesc(programType) {
    switch (programType) {
      case 700000000:
        return 'CEA BB';

      case 700000001:
      case 700000002:
        return 'EBB';

      case 700000003:
        return 'ESS';

      case 700000004:
        return 'EMR';

      default:
        return 'EBB';
    }
  }
}